import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { theme } from "../theme/theme";

/**
 * Typeahead rows under a search box. Tap adds the item; chips stay for
 * what is already selected.
 */
const SearchSuggestionList = ({
  items = [],
  getKey,
  getLabel,
  onPick,
  title = "Suggestions",
}) => {
  if (!items.length) return null;
  return (
    <View style={styles.wrap}>
      {title ? <Text style={styles.title}>{title}</Text> : null}
      {items.map((item) => {
        const label = getLabel(item);
        return (
          <TouchableOpacity
            key={getKey(item)}
            style={styles.row}
            onPress={() => onPick(item)}
            accessible={true}
            accessibilityRole="button"
            accessibilityLabel={`Add ${label}`}
            accessibilityHint="Adds this to your selected list"
          >
            <Text style={styles.label}>{label}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    marginBottom: theme.spacing.sm,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.sm,
  },
  row: {
    paddingVertical: theme.spacing.sm,
    paddingHorizontal: theme.spacing.xs,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.outline,
  },
  label: {
    fontSize: 16,
    color: theme.colors.onSurface,
    fontFamily: "Poppins",
  },
});

export default SearchSuggestionList;
